<div mat-dialog-content>
  <h3>{{ 'ORDERS.DIALOG.COMPLAINT.INFO' | translate }}</h3>
  <mat-form-field class="text-area">
    <mat-label class="complaint-label">{{ 'ORDERS.DIALOG.COMPLAINT.PLACEHOLDER' | translate }}</mat-label>
    <textarea matInput [formControl]="complaint"></textarea>
  </mat-form-field>
</div>
<div class="footer-complaint" mat-dialog-actions>
  <button
    mat-button
    (click)="onRegisterComplaint()"
    [disabled]="complaint.invalid || !!(complaintState$ | async)?.loading"
  >
    {{ 'ORDERS.DIALOG.COMPLAINT.BUTTON_CONFIRM' | translate }}
  </button>
  <mat-spinner *ngIf="(complaintState$ | async)?.loading" color="primary" diameter="20"></mat-spinner>
  <button mat-button mat-dialog-close>{{ 'ORDERS.DIALOG.COMPLAINT.BUTTON_CANCEL' | translate }}</button>
</div>
